<section class="video-player">
  <div class="player-layout">



    <video #videoel id="videoPlayer" class="single" playsinline="" style="" src="{{videoUrl}}" (suspend)="suspend($event)" (waiting)="waiting($event)" (emptied)="emptied($event)" (stalled)="stalled($event)"
     preload="auto" (click)="pause(); audio.playSoundClick();" (ended)="ended();" (play)="playStarted($event)" (playing)="playingEvent($event)" (pause)="paused();">
    </video>
  </div>
  <div class="progress-bar"  (click)="seek($event)">
    <div class="progress-line" >

    </div>
    <div class="progress-active-line" [ngStyle]="progressLineStyle">

    </div>
    <div class="progress-end" [ngStyle]="progressEndStyle">
    </div>
  </div>
  <div class="controls">
    <div class="inner-controls-wrapper">
      <!-- <span class="control repeat"><img src="/img/HUD/repeat.svg" alt="control" (click)="restart(); audio.playSoundClick();"></span> -->
      <div class="control skip">
        <app-button-skip alt="control" (click)="skip(); audio.playSoundClick();"></app-button-skip>
      </div>

      <div class="control play">
        <app-button-play alt="control" (click)="play(); audio.playSoundClick();"></app-button-play>
      </div>

      <div class="control replay">
        <app-button-replay alt="control" (click)="restart(); audio.playSoundClick();"></app-button-replay>
      </div>
      <!-- <img src="/img/HUD/play.svg" ></span> -->
      <!-- <span class="control close"><img src="/img/HUD/close.svg" alt="control" (click)="close(); audio.playSoundClick();"></span> -->
    </div>
  </div>
</section>
